export default __webpack_public_path__ + "favicon-16x16.v2.png";